import { render, staticRenderFns } from "./CoachAvailability.vue?vue&type=template&id=0ab4edc7"
import script from "./CoachAvailability.vue?vue&type=script&lang=js"
export * from "./CoachAvailability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports